/*
  thumb-variant-sync.js  (Indigo's Curve customization)
  Clicking a product media thumbnail (desktop or mobile), or swiping the
  mobile main gallery to a color photo, selects that photo's Color in the
  variant picker. It only "clicks" the theme's own Color input and fires the
  'change' event, so the theme updates price, availability, URL (?variant=)
  and the add-to-cart form exactly like a normal selection.
  Data comes from <script type="application/json" data-thumb-variant-map>
  rendered by snippets/thumb-variant-map.liquid.
*/
(function () {
  if (window.__thumbVariantSyncLoaded) return;
  window.__thumbVariantSyncLoaded = true;

  var SYNC_LOCK_MS = 2500; // max time we wait for the theme to finish a change
  var SWIPE_WINDOW_MS = 1500; // a slide change counts as a swipe if a touch ended this recently
  var state = new WeakMap(); // product-info -> { busy, busyUntil, lastTouch, ignoreUntil }

  function getState(pi) {
    var s = state.get(pi);
    if (!s) {
      s = { busyUntil: 0, lastTouch: 0, touching: false, ignoreUntil: 0, swipeTimer: null };
      state.set(pi, s);
    }
    return s;
  }

  function getMap(pi) {
    var el = pi.querySelector('script[data-thumb-variant-map]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function mediaIdFromTarget(target) {
    // data-target / data-media-id look like "<section-id>-<media-id>"
    if (!target) return null;
    var i = target.lastIndexOf('-');
    return i >= 0 ? target.slice(i + 1) : target;
  }

  function optionGroups(vs) {
    return Array.prototype.slice.call(vs.querySelectorAll('.product-form__input'));
  }

  function groupValue(group) {
    var sel = group.querySelector('select');
    if (sel) return sel.value;
    var checked = group.querySelector('input[type="radio"]:checked');
    return checked ? checked.value : null;
  }

  // Set a group's value WITHOUT firing change (used for the size fallback only)
  function setGroupSilently(group, value) {
    var sel = group.querySelector('select');
    if (sel) {
      var opt = Array.prototype.find.call(sel.options, function (o) { return o.value === value; });
      if (!opt) return false;
      Array.prototype.forEach.call(sel.options, function (o) { o.removeAttribute('selected'); });
      opt.setAttribute('selected', 'selected');
      sel.value = value;
      return true;
    }
    var input = Array.prototype.find.call(group.querySelectorAll('input[type="radio"]'), function (r) {
      return r.value === value;
    });
    if (!input) return false;
    input.checked = true;
    return true;
  }

  // Set a group's value and fire the change event the theme listens for
  function setGroupWithChange(group, value) {
    var sel = group.querySelector('select');
    if (sel) {
      var opt = Array.prototype.find.call(sel.options, function (o) { return o.value === value; });
      if (!opt) return false;
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    var input = Array.prototype.find.call(group.querySelectorAll('input[type="radio"]'), function (r) {
      return r.value === value;
    });
    if (!input) return false;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function sameOptions(a, b) {
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i] !== b[i]) return false;
    return true;
  }

  function selectColorForMedia(pi, mediaId, fromClick) {
    if (!pi || !mediaId) return;
    var map = getMap(pi);
    if (!map || map.colorIndex < 0 || !map.media) return;
    var color = map.media[String(mediaId)];
    if (color === undefined || color === null) return; // not a variant photo: do nothing

    var s = getState(pi);
    if (!fromClick && Date.now() < s.busyUntil) return; // swipe: a change is already in flight

    var vs = pi.querySelector('variant-selects');
    if (!vs) return;
    var groups = optionGroups(vs);
    var colorGroup = groups[map.colorIndex];
    if (!colorGroup) return;

    var current = groups.map(groupValue);
    if (current[map.colorIndex] === color) return; // already showing this color (also stops loops)

    var wanted = current.slice();
    wanted[map.colorIndex] = color;
    var variants = map.variants || [];
    var exists = variants.some(function (v) { return sameOptions(v.o, wanted); });

    if (!exists) {
      // Current size not offered in this color: fall back to an available variant of this color
      var fallback =
        variants.find(function (v) { return v.o[map.colorIndex] === color && v.a; }) ||
        variants.find(function (v) { return v.o[map.colorIndex] === color; });
      if (!fallback) return;
      for (var i = 0; i < groups.length; i++) {
        if (i !== map.colorIndex && fallback.o[i] !== current[i]) setGroupSilently(groups[i], fallback.o[i]);
      }
    }

    s.busyUntil = Date.now() + SYNC_LOCK_MS;
    if (!setGroupWithChange(colorGroup, color)) s.busyUntil = 0;
  }

  // Theme finished a variant change: release the lock, ignore the gallery's own re-scroll
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      document.querySelectorAll('product-info').forEach(function (pi) {
        var s = getState(pi);
        s.busyUntil = 0;
        s.ignoreUntil = Date.now() + 1200;
      });
    });
  }

  // 1) Thumbnail clicks (desktop thumbnail slider and mobile thumbnail carousel)
  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[id^="GalleryThumbnails"] [data-target] button');
    if (!btn) return;
    var item = btn.closest('[data-target]');
    var pi = btn.closest('product-info');
    if (!item || !pi) return;
    var mediaId = mediaIdFromTarget(item.dataset.target);
    // let the theme switch the big photo first, then sync the picker
    setTimeout(function () { selectColorForMedia(pi, mediaId, true); }, 0);
  });

  // 2) Swiping the main gallery on phones (only user swipes, never theme-driven scrolls)
  var mqlMobile = window.matchMedia('(max-width: 749px)');

  function bindViewer(viewer) {
    if (!viewer || viewer.dataset.thumbSyncBound) return;
    viewer.dataset.thumbSyncBound = 'true';
    var pi = viewer.closest('product-info');
    if (!pi) return;
    viewer.addEventListener('slideChanged', function (event) {
      if (!mqlMobile.matches) return;
      var s = getState(pi);
      var now = Date.now();
      if (now < s.ignoreUntil || now < s.busyUntil) return;
      if (!s.touching && now - s.lastTouch > SWIPE_WINDOW_MS) return; // not a user swipe
      var el = event.detail && event.detail.currentElement;
      if (!el || !el.dataset || !el.dataset.mediaId) return;
      var mediaId = mediaIdFromTarget(el.dataset.mediaId);
      clearTimeout(s.swipeTimer);
      s.swipeTimer = setTimeout(function () {
        if (Date.now() < getState(pi).ignoreUntil) return;
        selectColorForMedia(pi, mediaId);
      }, 600);
    });
  }

  function touchStart(event) {
    var viewer = event.target.closest && event.target.closest('[id^="GalleryViewer"]');
    if (!viewer) return;
    bindViewer(viewer);
    var pi = viewer.closest('product-info');
    if (pi) getState(pi).touching = true;
  }
  function touchEnd(event) {
    var viewer = event.target.closest && event.target.closest('[id^="GalleryViewer"]');
    if (!viewer) return;
    var pi = viewer.closest('product-info');
    if (!pi) return;
    var s = getState(pi);
    s.touching = false;
    s.lastTouch = Date.now();
  }
  document.addEventListener('touchstart', touchStart, { passive: true, capture: true });
  document.addEventListener('touchend', touchEnd, { passive: true, capture: true });
  document.addEventListener('touchcancel', touchEnd, { passive: true, capture: true });
})();
